import { render, staticRenderFns } from "./edit.presentations.page.vue?vue&type=template&id=1d500283&"
import script from "./edit.presentations.page.vue?vue&type=script&lang=js&"
export * from "./edit.presentations.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports